<template>
    <v-dialog v-model="dialog" persistent width="1000" transition="dialog-top-transition"
        @keydown.esc="visualizzaFile(null, null)">
        <v-card>
            <v-card-title class="ma-0 pa-0">
                <v-spacer />
                <v-btn icon @click="visualizzaFile(null, null)">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-row no-gutters>
                    <v-col cols="8" class="ma-0 pa-0">
                        <v-img v-on:dblclick.prevent="apriFile" v-if="selectedRow != null" :src="selectedRow.path"
                            :lazy-src="selectedRow.path" style="max-width: 35vh; cursor: pointer">
                            <template v-slot:placeholder>
                                <v-row justify-center fill-height>
                                    <v-progress-circular indeterminate color="grey" />
                                </v-row>
                            </template>
                        </v-img>
                    </v-col>

                    <v-col v-if="selectedRow != null" cols="4" class="ma-0 pa-0" style="font-size: 20px;">
                        <span>Nome: <b>{{ selectedRow.nome }}</b></span><br>
                        <span>Estensione: <b>{{ selectedRow.estensione }}</b></span><br>
                        <span>Dimensione: <b>{{ selectedRow.dimensione }}
                                {{ selectedRow.tipoDimensioneFile }}</b></span><br>
                        <span v-if="selectedRow.altezzaPX != ''">Altezza px: <b>
                                {{ selectedRow.altezzaPX }}</b></span><br>
                        <span v-if="selectedRow.larghezzaPX != ''">Larghezza px: <b>
                                {{ selectedRow.larghezzaPX }}</b></span>

                        <v-row no-gutters class="mt-5">
                            <v-btn small color="primary" @click="download()"><v-icon v-if="!loading"
                                    class="mr-1">download</v-icon>
                                <v-progress-circular v-else indeterminate dark class="mr-1" />
                                SCARICA FILE</v-btn>
                            <v-btn class="ml-1" small color="primary" @click="elimina(selectedRow)"><v-icon
                                    v-if="!loadingDelete" class="mr-1">delete</v-icon>
                                <v-progress-circular v-else indeterminate dark class="mr-1" />
                                ELIMINA FILE</v-btn>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {
    download_file, elimina_file
} from "@/api/api.archivio.js";

import mixinArchivio from "@/views/archivio/mixinArchivio";

export default {
    props: {
        dialog: { type: Boolean, default: false },
        selectedRow: { type: Object, default: null },
    },

    mixins: [mixinArchivio],

    data: () => ({
        loading: false,
        loadingDelete: false,
    }),

    methods: {
        visualizzaFile(file, value) {
            this.$emit("visualizzaFile", file, value);
        },

        apriFile() {
            window.open(this.selectedRow.path, "_blank");
        },

        async download() {
            //TODO: crittografia del percorso e del nome del file
            this.loading = true;

            let par = "?path=" + encodeURIComponent(this.selectedRow.path)
            const response = await download_file(par);
            //ricavo il tipo di file (estensione file)
            let url = response.config.url.split("%5C");
            let tipoFile = url[url.length - 1];
            tipoFile = tipoFile.split(".").pop();
            //setto il nome del file scaricato
            let nomeFile = this.selectedRow.nome;

            //download file
            this.downloadFile(response.data, tipoFile, nomeFile);

            this.loading = false;
        },

        async downloadFile(data, tipoFile, nomeFile) {
            let mimeTypes = this.getMimeTypes();
            let blob = new Blob([data], { type: mimeTypes[tipoFile] || "application/octet-stream" });
            let url = window.URL.createObjectURL(blob);

            let a = document.createElement("a");
            a.href = url;

            a.download = nomeFile;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            window.URL.revokeObjectURL(url);

            //window.open(url, "_blank");
        },

        async elimina(oggetto) {
            //E' un Pop-Up di conferma, come il 'toast'
            let confirm = await this.$confirm.open(
                "Elimina",
                "Eliminare il file: <br><b>" + oggetto.nome + oggetto.estensione + "</b>?"
            );
            if (!confirm) {
                this.loadingDelete = false;
                return;
            }
            this.loadingDelete = true;

            let par = "?path=" + encodeURIComponent(this.selectedRow.path)
            let res = await elimina_file(oggetto, par);

            if (res.data == "OK") {
                this.$toast.info("File eliminato con successo.");
                this.visualizzaFile(undefined, true);
            } else this.$toast.alert("Errore. Impossibile eliminare il file.");

            this.loadingDelete = false;
        },
    },
};
</script>